export default __webpack_public_path__ + "static/media/membersIcon.f1343cfd.png";